import React from "react";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import home from "../../../../common/assets/data/home";
import Section from "../../../utility/ui-components/section";
import Container from "../../../utility/ui-components/container";

function CounterSection() {
  const data = home.CounterSection;
  const list = home.WhyChooseUs;
  return (
    <Section className="bg-skylight">
      <Container>
        <div className="grid  grid-cols-1  md:grid-cols-7 ">
          <div className="m-auto mb-5 md:m-1 md:mx-auto md:col-span-2">
            <img src={list.img} className="w-[200px] h-[200px] md:w-[250px] md:h-[250px]  rounded-lg"></img>
          </div>
          <div className="grid md:col-span-5 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 ">
            {data.map(
              (count) =>
                count.isVisible && (
                  <div key={count.id} className="mb-10">

                    <div className="counter flex justify-center gap-4 border-b-2 border-secondary mr-5 shadow-xl">
                      <div>
                        <CountUp
                          end={count?.count}
                          decimals={count.decimals ? 1 : 0}
                          decimal={count.decimals ? "." : ""}
                          redraw={true}
                        >
                          {({ countUpRef, start }) => (
                            <VisibilitySensor onChange={start} delayedCall>
                              <span
                                className="text-[40px] text-secondary font-bold"
                                ref={countUpRef}
                              />
                            </VisibilitySensor>
                          )}
                        </CountUp>
                        <span className="text-2xl">{count.countSymbols}</span>
                        <p className="text-1xl font-bold  text-primary mb-2">
                          {count.counterText}
                        </p>
                      </div>
                      <div className="flex items-center justify-center mt-3 text-capitalize">
                        <img src={count.icon} width={40} />
                      </div>
                    </div>
                  </div>
                )
            )}
          </div>
        </div>
      </Container>
    </Section>
  );
}

export default CounterSection;
